import React, { Component } from 'react'
import { Redirect } from "react-router-dom";
import TitleBar from '../../components/title_bar';
import CheckPassword from '../../api/check_password';
import { SetPageBKColorWht } from '../../globals';
import MealFood from '../../images/meal-food.jpg';
import ProduceDept from '../../images/Produce-Dept.jpg';
import '../../css/common.css';
import '../../css/welcome.css';

class Welcome extends Component {

  constructor(props) {
    super(props);

    this.state = { passwordFail: false, passwordMsg: 'Sorry, unknown user or password', passwordChecked: false };
  }

  componentDidMount() {
    SetPageBKColorWht();
  }

  onCheckPassword () {
    CheckPassword(this.refs.txtUserId.value, this.refs.txtPassword.value, this);
  }

  onNewAccout () {
    this.props.history.push('/new_acct');
  }

  onFindAccout () {
    this.props.history.push('/find_acct');
  }

  render() {

    if (this.state.passwordChecked) {
      return <Redirect to="/main" push={ true } />
    }

    if (this.state.bypassWelcome) {
      return { }
    }

    return (
      <div id="welcome-main" className="wht-bk">
        <TitleBar showContact={true} />
        <div id="main-cell-left" className="ultra-light-bk"></div>
        <div id="main-cell-right"></div>
        <div id="main-circle-outer">&nbsp;
          <div id="main-circle" className="highlight-font light-bk">&nbsp;
            <div id="welcome">Welcome to myDineStein</div>
            <div id="signon">Sign On</div>
            <div className="signOnText" >
              <input id="txtUserId" ref="txtUserId" autoCapitalize="none" placeholder="UserId" className="highlight-font" />
            </div>
            <div className="signOnText" >
              <input id="txtPassword" ref="txtPassword" autoCapitalize="none" placeholder="Password" className="highlight-font"/>
            </div>
            <div onClick={ ()=>{ this.onCheckPassword() }} id="signon-btn" className="btn-bk">Sign On</div>
            <div id="password-fail" className="bad-password main-font" style ={ this.state.passwordFail ? {} : { display: 'none'} } >
              {this.state.passwordMsg}
            </div>
            <div id="signon-forgot-new">
              <span onClick={ ()=>{ this.onFindAccout() }} id="signon-forgot-info">Forgot Info</span>
              <span onClick={ ()=>{ this.onNewAccout() }} id="signon-new-account">New Account</span>
            </div>
          </div>
        </div>
        <div className="section-title highlight-font"><span>About Us</span></div>
        <div id="spoons-table">&nbsp;</div>
        <div id="your-busy-header" className="highlight-font"><span>You're busy, we're here to help</span></div>
        <div id="your-busy-body" className="main-font"><span>Shopping doesn't have to be hard. With DineStein to help you shoping can be easy and dare we say it? Fun! DineStein helps you manage your recipes, your pantry, your time. And because an entire family can share an account everyone can collaborate to keep the weekly shopping trip in synch with everyone's needs that week.</span></div>
        <div id="divTwoCol" className="main-font divTwoCol">
          <div id="divTwoCol1">
            <img alt="" src={MealFood} className="imgMealFood" />
            <div id="your-busy-pics-desc-hdr-1" className="bold lrg-main-font">Plan Your Meals</div>
            <div id="your-busy-pics-desc-body-1">Use your recipes or choose from the huge online library we provide. Need to add or subtract servings? No problem. Add sundries and other items to your list. Everyone in the family can contribute.</div>
          </div>
          <div  id="divTwoCol2">
            <img alt="" src={ProduceDept} className="imgMealFood" />
            <div id="your-busy-pics-desc-hdr-3" className="bold lrg-main-font">Never Forget an Item</div>
            <div id="your-busy-pics-desc-body-2">Your meals and sundry items are added to a convenient shopping list. The items will be organized by area in the store. Produce, baking, deli... you get the idea. It makes moving through the store quickly and easily a breeze. See an item on special in the store? Add it to your list, and if you like DineStein can suggest a recipe and add it's items for you as well. Easy!</div>
          </div>
        </div>
      </div>
    );
  }
}

export default Welcome;



// WEBPACK FOOTER //
// ./src/pages/welcome/welcome.js